module.exports = __webpack_public_path__ + "img/info_icon.42932429.svg";